import { DesignItems } from 'records/DesignItem';
import BaseList from 'records/BaseList';

import {
  DESIGN_ITEMS_ASYNC_ACTION_START,
  DESIGN_ITEMS_ASYNC_ACTION_ERROR,
  DESIGN_ITEMS_ASYNC_ACTION_SUCCESS,
  DESIGN_ITEMS_UPDATE_ACTION_SUCCESS,
  DESIGN_ITEMS_RESET_STATE,
} from 'actions/designItems';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: DesignItems(),
});

const actionsMap = {
  [DESIGN_ITEMS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_ITEMS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_ITEMS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignItems(action.data),
    });
  },
  [DESIGN_ITEMS_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new BaseList({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGN_ITEMS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function designItems(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
